import { IntegrationServices } from '@sequencehq/api/utils'
import { FeatureFlags } from 'hooks/useFeatureFlags'

export const shouldShowPaymentStatusWarning = (args: {
  service: IntegrationServices
  isStripeEnabled: boolean
  flags: Pick<FeatureFlags, 'onLedger'>
  isXeroPaymentSyncEnabled?: boolean
}): boolean => {
  const isReconciledByService =
    (args.service === 'QuickBooks_Online' && args.flags.onLedger) ||
    (args.service === 'Xero' && args.isXeroPaymentSyncEnabled === true)

  return args.isStripeEnabled && !isReconciledByService
}
